<template>
    <div class="navigation-account__language-content d-block">
        <b-dropdown>
            <template slot="button-content">
                <span
                    class="navigation-account__language-dropdown-toggle d-flex align-items-center"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="true"
                    @click="openNavigation()"
                >
                    <span class="navigation-account__language-icon"><iconLanguage class="d-block"/></span>
                    <span class="navigation-account__language-selected">
                        {{ LANGUAGES[$i18n.locale] }}
                    </span>
                </span>
            </template>
            <b-dropdown-item :class="{ active: isActiveLanguage('en') }" @click="updateLanguage('en')">
                {{ $t('english') }}
            </b-dropdown-item>
            <b-dropdown-item :class="{ active: isActiveLanguage('de') }" @click="updateLanguage('de')">
                {{ $t('german') }}
            </b-dropdown-item>
            <b-dropdown-item :class="{ active: isActiveLanguage('zh-cn') }" @click="updateLanguage('zh-cn')">
                {{ $t('chinese') }}
            </b-dropdown-item>
        </b-dropdown>
    </div>
</template>

<script>
import iconLanguage from '@/assets/img/account/nav-icons/language.svg?inline';
import { LudumEventBus, TOGGLE_NAVIGATION } from '@/event-bus';

export default {
    components: {
        iconLanguage
    },

    data() {
        return {
            LANGUAGES: {
                en: this.$t('english'),
                de: this.$t('german'),
                'zh-cn': this.$t('chinese')
            }
        };
    },

    watch: {
        '$i18n.locale': {
            immediate: true,
            handler(locale) {
                if (locale === 'de') {
                    document.body.classList.add('body-german-language');
                }
            }
        }
    },

    methods: {
        isActiveLanguage(language) {
            return this.$i18n.locale === language;
        },

        updateLanguage(lang) {
            this.$store.dispatch('post', {
                url: api + 'update-preferred-language',
                data: {
                    preferred_language: lang
                }
            }).then(response => {
                Vue.cookie.set('language', lang);
                localStorage.setItem('language', lang);
                this.$i18n.locale = lang;
                axios.defaults.headers.common['Accept-Language'] = lang;
                document.querySelector('html').setAttribute('lang', lang);

                this.$store.dispatch('notifySuccess', response);
                setTimeout(() => { location.reload(); }, 1000);
            }).catch(error => {
                this.$store.dispatch('notifyError', error);
            });
        },

        openNavigation() {
            let appContentClass = document.getElementById('app-content').classList.contains('close-navigation');
            let navClass = document.getElementById('navigation-account').classList.contains('is-open-nav');
            if (appContentClass && !navClass) {
                LudumEventBus.$emit(TOGGLE_NAVIGATION);
            }
        }
    }
};
</script>
